// (C) Copyright 2015 Moodle Pty Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { Injectable } from '@angular/core';

import { CoreConfig, CoreConfigProvider } from '@services/config';
import { FreemiumSites } from './sites';

/**
 * Override config provider to add functionality specific to freemium.
 */
@Injectable({ providedIn: 'root' })
export class FreemiumConfigProvider extends CoreConfigProvider {

    /**
     * @inheritdoc
     */
    async initialize(): Promise<void> {
        await this.loadSubscriptionConfig();
        await super.initialize();
    }

    /**
     * Load development config overrides.
     */
    protected async loadSubscriptionConfig(): Promise<void> {
        const subscription = await FreemiumSites.getCurrentSiteSubscriptionFromDB();

        subscription?.appConfig && CoreConfig.patchEnvironment(subscription.appConfig);
    }

}
